// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"a3211a75","283":"04580591","412":"6e059059","453":"f488a80e","768":"6023bbca","913":"06dddc80"}[chunkId] + ".chunk.js";
};